import { FC, ReactNode } from 'react';

interface DeliverableCardProps {
  children: ReactNode;
  onClick?: () => void;
}

const CARD_CLASSES = 'bg-white border border-day-light-2 rounded-md p-4';
const CLICKABLE_CLASSES =
  'w-full text-left hover:border-day-primary hover:shadow-sm transition-shadow';

export const DeliverableCard: FC<DeliverableCardProps> = ({ children, onClick }) =>
  onClick ? (
    <button type="button" className={`${CARD_CLASSES} ${CLICKABLE_CLASSES}`} onClick={onClick}>
      {children}
    </button>
  ) : (
    <div className={CARD_CLASSES}>{children}</div>
  );
